(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    (function (Forms, $, undefined) {

        /**
         * @memberOf Lfl.Forms
         */
        Lfl.Forms.AjaxFormSubmitter = Lfl.Forms.AjaxFormSubmitter || {};

        (function (AjaxFormSubmitter, $, undefined) {

            /**
             * Returns the parent form of the button with provided path.
             *
             * @memberOf Lfl.Forms.AjaxFormSubmitter
             *
             * @return {*|HTMLElement}
             * @param buttonPath
             */
            AjaxFormSubmitter.getParentForm = function (buttonPath) {
                const $button = $(buttonPath);

                return $($button.closest('form'));
            };

            /**
             * Registers the given form to be submitted asynchronously by AJAX.
             *
             * Note: this method covers not only button click submission but any form of submission of the given form
             * (e.g. via hotkeys).
             *
             * @param {object} parameters
             * @param {jQuery} parameters.$form A jQuery wrapper of the form.
             * @param {string} [parameters.url] The url to post the form to if it is not the same as the form's action attribute.
             * @param {string} [parameters.method] The HTTP method (post, get, ... ).
             * @param {function} [parameters.successCallback] The function which should be called if form was submitted
             * successfully
             * @param {function} [parameters.errorCallback] The function which should be called if form was NOT
             * submitted successfully
             * @param {function} [parameters.preSubmitCallback] The function which should be called before form submission
             *
             * @memberOf Lfl.Forms.AjaxFormSubmitter
             */
            AjaxFormSubmitter.registerFormToBeSubmittedAsynchronously = function (parameters) {
                parameters.$form.submit(function (e) {
                    AjaxFormSubmitter.submit(parameters);

                    e.preventDefault();
                });

            };

            /**
             * Immediately submits the data from given form.
             *
             * Note: it is recommended to use the registerFormToBeSubmittedAsynchronously method on the entire form,
             * because it handles different methods of submission.
             *
             * @param {object} parameters
             * @param {jQuery} parameters.$form A jQuery wrapper of the form.
             * @param {string} [parameters.url] The url to post the form to if it is not the same as the form's action attribute.
             * @param {string} [parameters.method] The HTTP method (post, get, ... ).
             * @param {function} [parameters.successCallback] The function which should be called if form was submitted
             * successfully
             * @param {function} [parameters.errorCallback] The function which should be called if form was NOT
             * submitted successfully
             * @param {function} [parameters.preSubmitCallback] The function which should be called before form submission
             *
             * @memberOf Lfl.Forms.AjaxFormSubmitter
             */
            AjaxFormSubmitter.submit = function (parameters) {
                const $form = parameters.$form;
                let url = parameters.url;
                let method = parameters.method;

                const successCallback = parameters.successCallback;
                const errorCallback = parameters.errorCallback;
                const preSubmitCallback = parameters.preSubmitCallback;

                if (typeof url === 'undefined') {
                    url = $form.attr('action');
                }

                if (typeof method === 'undefined') {
                    method = 'post';
                }

                let data;

                if (typeof preSubmitCallback !== 'undefined') {
                    data = preSubmitCallback($form, false).serialize();
                } else {
                    data = $form.serialize()
                }

                $.ajax({
                    type: method,
                    url: url,
                    data: data,
                    success: function (receivedData) {
                        if (typeof successCallback !== 'undefined') {
                            successCallback(receivedData);
                        }

                        Lfl.Ajax.ResponseParser.processFormSubmissionSuccessResponse(receivedData, $form);
                    },
                    error: function (receivedData) {
                        if (typeof errorCallback !== 'undefined') {
                            errorCallback(receivedData);
                        } else {
                            Lfl.Ajax.ResponseParser.processFormSubmissionErrorResponse(receivedData, $form);
                        }
                    }
                });

            }

        }(Forms.AjaxFormSubmitter = Forms.AjaxFormSubmitter || {}, jQuery));
    }(Lfl.Forms = Lfl.Forms || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
